document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cst-product-jump-button a').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Adjust offset based on screen width
                let offset = window.innerWidth < 768 ? 200 : 150; // Smaller offset for mobile, larger for desktop

                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // Optional: Adjust URL without page reload
                history.pushState(null, null, '#' + targetId);
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
  const textContent = document.getElementById("text-content");
  const showMoreBtn = document.getElementById("show-more-btn");

  // Count the number of words in the text content
  const wordCount = textContent.innerText.split(/\s+/).length;

  // If the word count is more than 100, enable the Read More / Show Less functionality
  if (wordCount > 100) {
    // Show the Read More button
    showMoreBtn.style.display = "inline";

    // Initially set the text content to be collapsed
    textContent.classList.add("collapsed");

    showMoreBtn.addEventListener("click", function () {
      if (textContent.classList.contains("expanded")) {
        textContent.classList.remove("expanded");
        textContent.classList.add("collapsed");
        showMoreBtn.textContent = "...Read More";
      } else {
        textContent.classList.remove("collapsed");
        textContent.classList.add("expanded");
        showMoreBtn.textContent = "Show Less";
      }
    });
  }
});


// Readmore
document.querySelector('.show-more__button').addEventListener('click', function() {
  const container = document.querySelector('.read-more__container');
  const button = document.querySelector('.show-more__button');

  container.classList.toggle('expanded');
  
  // Toggle button text
  if (container.classList.contains('expanded')) {
    button.textContent = 'Read Less';
  } else {
    button.textContent = 'Read More';
  }
});
